import classnames from "classnames";
import * as React from "react";

export interface LayoutPlaceProps {
  className?: string;
  children?: any;
  style?: React.CSSProperties;
}

export default (props: LayoutPlaceProps) => (
  <div className={classnames("wsc_place", props.className)} style={props.style}>
    {props.children}
  </div>
);
